// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__Pbdnx","icon":"SortAdornment_icon__2june","up":"SortAdornment_up__3lCvW","down":"SortAdornment_down__2d_NC","active":"SortAdornment_active__3VU1m"};